import { render } from "./IconSeparator.vue?vue&type=template&id=0a80d7fa"
import script from "./IconSeparator.vue?vue&type=script&lang=js"
export * from "./IconSeparator.vue?vue&type=script&lang=js"
script.render = render

export default script